import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { saveLocalData } from "../../helpers/storage-helper";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { cuteToast } from "../UI/cute";
import {BsCheckCircle} from "react-icons/bs";
import {FaRegTimesCircle} from "react-icons/fa";
import { access_specifier } from "../../config/app.config";
import { authActions } from "../../store/auth";

const UserProfile = () => {
  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    access:[],
    app_all_access : [],
    upgrade_access : []
  });

  const dispatch = useDispatch();

  
  useEffect(() => {
    document.title = `${endPoints.title} | Profile`;
    dispatch(authActions.setLoaderStatus({ status: false }));
  });

  const email = useSelector((state) => state.auth.email);
  const first_name = useSelector((state) => state.auth.first_name);

  const last_name = useSelector((state) => state.auth.last_name);

  const myAccess = useSelector((state) => state.auth.access);

  const { sendRequest } = useHttp();

  const [showProfile, setShowProfile] = useState(true);

  useEffect(() => {

    if(myAccess){
      myAccess.includes("91") && setShowProfile("false"); // 91 is for JV Access
    }

    const have_access = myAccess.split(",").includes("5") ? myAccess.split(",").filter(item => item !== "5" || item !== "" || item !== "9A") : myAccess.split(",").filter(Boolean); // 5 is for admin
    const app_all_access = Object.keys(access_specifier).filter(value => /[A-Z]/.test(value));
    const difference = app_all_access.filter(x => have_access.indexOf(x) === -1);
    
    var upgrade_access = have_access.filter( x => x === "8A" || x === "8B").length > 0 ? difference.filter( x => x !== "8A" && x !== "8B"): difference ;

        upgrade_access = have_access.filter( x => x === "1a").length > 0 ? upgrade_access.filter( x => x === "---"): upgrade_access ; // 1a is for fastpass offer
        upgrade_access = have_access.filter( x => x === "8A").length > 0 ? upgrade_access.filter( x => x === "---"): upgrade_access ; // 1a is for fastpass offer
    
    // console.log(have_access,my_access,app_all_access)
    var my_access = have_access.filter( x => x === "1a").length > 0 ? Object.keys(access_specifier).filter(item=> item !== "8A" &&  item !== "5" ) : have_access ; // 1a is for fastpass offer
    
      my_access = have_access.filter( x => x === "8A").length > 0 ? Object.keys(access_specifier).filter(item=> item !== "1a" &&  item !== "5" ) : my_access ; // 8A is for Bundle 

      my_access = (have_access.includes("1a") && have_access.includes("8B")) ? [...my_access,"8B"] : my_access ; // 1a is for fastpass offer
      my_access = (have_access.includes("1a") && have_access.includes("8A")) ? [...my_access,"8A"] : my_access ; // 1a is for fastpass offer
      my_access = have_access.includes("8a") ? [...my_access,"8a"] : my_access ; // 1a is for fastpass offer
      my_access = have_access.includes("8b") ? [...my_access,"8b"] : my_access ; // 1a is for fastpass offer
    
    // console.log(my_access);

    setProfile({
      first_name,
      last_name,
      email,
      password: "",
      access: my_access,
      app_all_access ,
      upgrade_access
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    sendRequest(
      {
        url: endPoints.updateprofile,
        body: profile,
        method: "POST",
      },
      (response) => {
        if (response.id) {
          cuteToast({
            type: "success",
            message: "successfully updated",
            timer: 5000,
            title: "Profile Updated",
          });

          saveLocalData("vidamaze_user", response);
        } else {
          cuteToast({
            type: "error",
            message: "Something went wrong!",
            timer: 5000,
            title: response.message,
          });
        }
        // console.log(status);
      }
    );
  };

  return (
    <div className="mid_wrap">
      <div className="container">
        { showProfile ? (
          <>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-4 pb-2">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Profile
                </li>
              </ol>
            </nav>

            <div className="row">
              <div className="col-md-4">
                <div className="card">
                  <div className="card-header text-center">
                    <h4 className="card-title">Update Profile</h4>
                  </div>
                  <div className="card-body">   
                    <div className="p-1">
                      <form action="" onSubmit={handleSubmit}>
                        <h5 className="mb-4 pb-3 small_title d-flex" style={{wordBreak:"break-all"}}>{profile.email}</h5>
                        <div className="mb-3">
                          <label className="form-label">First Name : </label>
                          <input
                            type="text"
                            value={profile.first_name}
                            onChange={(e) => {
                              setProfile({
                                ...profile,
                                first_name: e.target.value.trim(),
                              });
                            }}
                            className="form-control"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Last Name : </label>
                          <input
                            type="text"
                            value={profile.last_name}
                            onChange={(e) => {
                              setProfile({ ...profile, last_name: e.target.value });
                            }}
                            className="form-control"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Password : </label>
                          <input
                            type="password"
                            value={profile.password}
                            onChange={(e) => {
                              setProfile({
                                ...profile,
                                password: e.target.value.trim(),
                              });
                            }}
                            className="form-control"
                          />
                        </div>
                        <input type="submit" value="update" className="btn w-100" />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-8">
                <div className="card">
                  <div className="card-header text-center">
                    <h4 className="card-title">My Access</h4>
                  </div>
                  <div className="card-body">    
                    <div className="row">
                        <div className="col-md-12">
                          <h6><strong>Current Access : </strong></h6>
                          <div className="row my-4">
                            {profile.access && profile.access.map((item, index) => {
                                return (
                                  <div className="col-md-4 mb-4" key={index}>
                                    <div className="card text-center">
                                      <div className="card-body">
                                        <div className="py-4">
                                          {/* <i className="ion ion-ios-checkmark-circle-outline display-4 text-success"></i> */}
                                          <BsCheckCircle className="text-success" size={44}/>
                                          <h5 className="text-primary mt-4">{access_specifier[item]}</h5>
                                        </div>
                                      </div>
                                    </div>                    
                                  </div>
                                );  
                            })} 
                          </div> 
                        </div>
                        {profile.upgrade_access && profile.upgrade_access.length > 0 && (
                          <div className="col-md-12">
                            <h6><strong>You haven't bought yet. Would you like to upgrade?  </strong></h6>
                            <div className="row my-4">
                              {profile.upgrade_access && profile.upgrade_access.map((item, index) => {
                                  return (
                                    <div className="col-md-4 mb-4" key={index}>
                                      <div className="card text-center">
                                        <div className="card-body">
                                          <div className="py-4">
                                            <FaRegTimesCircle size={44} className="text-danger"/>
                                            <h5 className="text-primary mt-4">{access_specifier[item]}</h5>
                                            <div className="mt-4">
                                                <a href={`${process.env.PUBLIC_URL}/upgrade-access/${btoa(item)}`} rel="noreferrer" target="_blank" className="btn btn-sm btn-primary p-2 rounded">Upgrade Your Access</a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>                    
                                    </div>
                                  );  
                              }
                              )}
                            </div>
                          </div> 
                        )}         
                    </div>
                  </div>  
                </div>
              </div>
            </div>
          </> 
        ) : (
        <div className="emptyDiv pt-5">
          <h1 className="mb-4" style={{fontWeight:900}}>Forbidden Access</h1>
      
          <h2 className="mb-4">Uh Oh! You dont have permission to access this page! </h2>
          <p className="message__text">
            We're sorry, the page you were looking for not accesible for this type of User. The link
            you followed may either be broken or no longer exists. Please try again,
            or take a look at our.
          </p>
          <p className="message__text">
            Let's go <Link to="/">home</Link> and try from home
          </p>
        </div>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
